import React from 'react';
import { DndProvider } from 'react-dnd';
import TouchBackend from 'react-dnd-touch-backend';
import HTML5Backend from 'react-dnd-html5-backend';

const isTouchDevice = typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
const dndBackend = isTouchDevice ? TouchBackend : HTML5Backend;
const dndBackendOptions = isTouchDevice ? { enableMouseEvents: true } : {};

const AppDndProvider = ({ children }) => (
  <DndProvider backend={dndBackend} options={dndBackendOptions}>
    {children}
  </DndProvider>
);

export default AppDndProvider;
